import React, { FC } from 'react'
import { Link } from 'react-router-dom'

import { getOrganizationInfo, createPath } from '@utils/utils'

import TokensService from '@services/tokensService';
import { actions as menuActions } from '@store/modules/navigation/actions'

import { AllLinkProps as IProps } from './types'

const OrganizationLink: FC<IProps> = (props) => {
  const {
    to,
    alias,
    oguid,
    dispatch,
    isRootMode,
    num,
    onClick,
    ...rest
  } = props

  const authorized = TokensService.checkAccessToken()

  if (!authorized || isRootMode) return <Link to={to} {...rest} />

  const organization = getOrganizationInfo(alias, oguid)

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    num!==undefined && dispatch(menuActions.setTaskIdx(num))
    onClick?.(e)
  }

  return <Link to={createPath(organization, to)} {...rest} onClick={handleLinkClick}/>
}

export default OrganizationLink
